import { render, staticRenderFns } from "./BigCoupon.vue?vue&type=template&id=69af3fb7&scoped=true"
import script from "./BigCoupon.vue?vue&type=script&lang=js"
export * from "./BigCoupon.vue?vue&type=script&lang=js"
import style0 from "./BigCoupon.vue?vue&type=style&index=0&id=69af3fb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69af3fb7",
  null
  
)

export default component.exports